module.exports = __webpack_public_path__ + "img/BIX.94fe1fce.svg";